export default {
	tabs: ["Befizetés", "Történelem"],
	History: {
		tabs: ["Felülvizsgálat", "Siker", "Elutasítás"]
	},
	AccountAmount: "Számla összege",
	ContactCustomerService: "Kapcsolatfelvétel az ügyfélszolgálattal",
	NoCustomerService: "Ügyfélszolgálat elfoglalt",
	tips: "Kérjük, adja be az előző értékelést, mielőtt folytatná a következő értékelést"
};
